import axios from 'axios';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

class AuthService {
    constructor() {
        // Initialize auth and provider lazily
        this._auth = null;
        this._provider = null;
    }

    get auth() {
        if (!this._auth) {
            this._auth = getAuth();
        }
        return this._auth;
    }

    get provider() {
        if (!this._provider) {
            this._provider = new GoogleAuthProvider();
        }
        return this._provider;
    }

    async signInWithGoogle() {
        try {
            const result = await signInWithPopup(this.auth, this.provider);
            const user = result.user;
            const idToken = await user.getIdToken();
            
            // Store token
            this.setToken(idToken);
            
            // Store user info
            localStorage.setItem('user', JSON.stringify({
                uid: user.uid,
                email: user.email,
                displayName: user.displayName,
                photoURL: user.photoURL
            }));

            return { success: true, user };
        } catch (error) {
            console.error("Error signing in with Google: ", error);
            throw error;
        }
    }

    setToken(token) {
        localStorage.setItem('auth_token', token);
    }

    getToken() {
        return localStorage.getItem('auth_token');
    }

    logout() {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
    }
}

// Export the class instead of an instance
export const AuthServiceClass = AuthService;
// Create a single instance that can be imported
export const authService = new AuthService(); 